module.exports = __webpack_public_path__ + "static/media/40.1a1cab94.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/style/img/monuments/polished/40.jpg
// module id = 601
// module chunks = 0